import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import React, { useEffect, useState } from "react";
import index from "./pages/Home";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import Index from "./pages/Contact/Index";
import { config } from "./pages/config";
import AboutUs from "./pages/About/AboutUs";
import "./assets/styles/About.css";
import Loader from "./components/common/Loader";
import ScrollToTop from "./components/common/ScrollToTop";
import Footer from "./components/common/Footer";
import PrivacyPolicy from "./pages/Privacy Policy/PrivacyPolicy";
import TermsCondition from "./pages/Privacy Policy/TermsCondition";
import Jewellery from "./pages/Product/Jewellery";
function App() {
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    setTimeout(() => setLoading(false), 1900)
  }, [])
  if (loading) {
    return <Loader />
  }

  return (
    <div>
      <BrowserRouter>
      <ScrollToTop />
        <Routes>
          <Route path={`${config.appUrl}`} Component={index} />
          <Route path={`${config.appUrl}contact-us`} Component={Index} />
          <Route path={`${config.appUrl}about-us`} Component={AboutUs} />
          <Route path={`${config.appUrl}collections`} Component={Jewellery} />
          <Route path={`${config.appUrl}privacy-policy`} Component={PrivacyPolicy} />
          <Route path={`${config.appUrl}terms-and-condition`} Component={TermsCondition} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
